import React, { useRef } from "react";
import { Image } from "react-konva";
import useImage from "use-image";

const LayerImage = ({
  imageLayer,
  isSelected,
  onSelect,
  onDragEnd,
  onTransformEnd,
  isCtrlPressed,
  setMenuVisiblePosition,
  setMenuVisible,
  setMenuVisibleLayerID,
  onDragMove,
  ratio
}) => {
  const [img] = useImage(imageLayer.url);
  
  const imageRef = useRef();

  const handleContextMenu = (e, img) => {
    e.evt.preventDefault();
    setMenuVisiblePosition({ x: e.evt.clientX, y: e.evt.clientY });
    setMenuVisibleLayerID(img.id);
    setMenuVisible(true);
  };
  return (
    <Image
      ref={imageRef}
      image={img}
      {...imageLayer}
      strokeWidth={imageLayer.strokeWidth / ratio}
      shadowOffsetX={imageLayer.shadowOffsetX / ratio}
      shadowOffsetY={imageLayer.shadowOffsetY / ratio}
      // id={imageLayer.id}
      // x={imageLayer.x}
      // y={imageLayer.y}
      // width={imageLayer.width}
      // height={imageLayer.height}
      // visible={imageLayer.visible || false}
      // rotation={imageLayer.rotation}
      // zIndex={imageLayer.zIndex || 1}
      draggable={isCtrlPressed}
      onClick={onSelect}
      onTap={onSelect}
      onDragEnd={onDragEnd}
      onTransformEnd={onTransformEnd}
      onContextMenu={(e) => handleContextMenu(e, imageLayer)}
      onDragMove={onDragMove}
    />
  );
};

export default LayerImage;
